import axios from 'axios';

export const listFinancialSnapshotVersionsApi = async (customerId) => {
  const response = await axios.get(
    `/admin/customer/${customerId}/financial-snapshot-versions`
  );
  return response.data;
};

export const getFinancialSnapshotVersionApi = async (id) => {
  const response = await axios.get(`/admin/financial-snapshot-versions/${id}`);
  return response.data;
};

export const saveFinancialSnapshotVersionApi = async (customerId, data) => {
  const response = await axios.post(
    `/admin/customer/${customerId}/financial-snapshot-versions`,
    data
  );
  return response.data;
};

export const deleteFinancialSnapshotVersionApi = async (id) => {
  await axios.delete(`/admin/financial-snapshot-versions/${id}`);
};
